var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "offer-attributes" },
    [
      _c(
        "div",
        { staticClass: "offer-details" },
        [
          _c(
            "div",
            { staticClass: "row mb-2" },
            [
              _c("h2", {
                staticClass: "mt-3",
                domProps: { textContent: _vm._s(_vm.title) },
              }),
              _vm._v(" "),
              _vm._l(_vm.details, function (detail, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12 col-md-6" },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("p", { staticClass: "pe-1" }, [
                        _c("span", {
                          staticClass: "icon h1",
                          class: detail.icon,
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-1" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "safe-html",
                              rawName: "v-safe-html",
                              value: detail.descriptionBbcode,
                              expression: "detail.descriptionBbcode",
                            },
                          ],
                          staticClass: "px-1 pb-1",
                        }),
                      ]),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.zigZag
            ? _c("EditorialPush", {
                staticClass: "mt-1",
                attrs: { zigzag: _vm.zigZag },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.genericButtonCta
        ? _c("div", { staticClass: "mt-1 px-1 px-md-0 border border-gray2" }, [
            _c("div", { staticClass: "bg-white px-2 py-2" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column flex-md-row justify-content-md-between align-items-md-start",
                },
                [
                  _c("h3", { staticClass: "mb-0 align-self-md-center" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.offerName) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column align-items-start align-items-md-end",
                    },
                    [
                      _c("Price", {
                        staticClass: "price-align",
                        attrs: {
                          price: _vm.price.price,
                          "initial-price": _vm.price.initialPrice || undefined,
                          "price-details": _vm.price.priceDetails
                            ? _vm.price.priceDetails
                            : undefined,
                          "show-from": _vm.price.showFrom,
                          "show-by-month": _vm.price.showByMonth,
                          "show-promo-duration": _vm.price.showPromoDuration,
                          "show-end-of-promotion-price":
                            _vm.price.showEndOfPromotionPrice,
                          duration: _vm.price.duration,
                          "is-cents-format": false,
                          "is-compact": _vm.price.compact,
                        },
                      }),
                      _vm._v(" "),
                      _c("generic-button-cta", {
                        staticClass: "w-100",
                        attrs: {
                          "dto-from-object": _vm.genericButtonCta,
                          "css-classes": "btn-primary w-100 mw-100",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.editoPopins, function (editoPopin) {
        return _c("EditoPopin", {
          key: editoPopin.popinModal.id,
          attrs: {
            "popin-id": editoPopin.popinModal.id,
            title: editoPopin.title,
            visual: editoPopin.visual,
            sections: editoPopin.sections,
            mentions: editoPopin.mentions,
          },
        })
      }),
      _vm._v(" "),
      _vm.mobileOptionPopin
        ? _c("OptionEditoPopin", {
            attrs: {
              "popin-id": _vm.mobileOptionPopin.popinModal.id,
              title: _vm.mobileOptionPopin.title,
              visual: _vm.mobileOptionPopin.visual,
              sections: _vm.mobileOptionPopin.sections,
              mentions: _vm.mobileOptionPopin.mentions,
              price: _vm.mobileOptionPopin.priceInCents,
              "alert-message": _vm.mobileOptionPopin.alertMessage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.destinationPopin
        ? _c("ThreeColumnsEditoPopin", {
            attrs: {
              "popin-id": _vm.destinationPopin.popinModal.id,
              title: _vm.destinationPopin.title,
              visual: _vm.destinationPopin.visual,
              sections: _vm.destinationPopin.sections,
              mentions: _vm.destinationPopin.mentions,
              "first-column-sections": _vm.destinationPopin.firstColumnSections,
              "second-column-sections":
                _vm.destinationPopin.secondColumnSections,
              "third-column-sections": _vm.destinationPopin.thirdColumnSections,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }